var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShoppingCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 19.5,
  r: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 19.5,
  r: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 6H8l-.62-2.62A.51.51 0 0 0 6.89 3H3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.83a.49.49 0 0 1 .48.38l3.06 12.24a.51.51 0 0 0 .49.38h9.14a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7.58a.49.49 0 0 1-.48-.38L10 14h8.7a.51.51 0 0 0 .49-.38l1.76-7A.49.49 0 0 0 20.5 6Z"
})));
export default SvgShoppingCart;